import JournalTextArticlePage from './JournalTextArticlePage'

/**
 * Piece: I See Both Sides, Like Chanel — same layout as sustainability essay (text, not PDF).
 */
export default function SeeBothSidesChanel() {
  return (
    <JournalTextArticlePage title="I See Both Sides, Like Chanel" titleFont='"Helvetica Neue", Helvetica, Arial, sans-serif'>
      <p className="journalTextArticleMeta">By: Kalkidane Negewo</p>
      <p className="journalTextArticleMeta">July 2024</p>
      <p>
        In all parts of life, change is inevitable. This has been specifically prevalent throughout
        the fashion industry as many high-profile changes have been rolling out as of this last
        year. From Pharrell&apos;s appointment at Louis Vuitton, Alessandro Michele leaving Gucci
        to replace Pierpaolo Piccioli at Valentino, Sarah Burton leaving her legacy at Alexander
        McQueen, or Dries Van Noten leaving his eponymous brand. So, when the fashion world was
        informed of the departure of Chanel&apos;s artistic director, Virginie Viard, the abrupt,
        yet inevitable, change hit the airwaves immediately.
      </p>
      <p>
        Fashion enthusiasts everywhere were taken aback at the announcement of the exit of Viard
        who has dedicated the last 37 years of her life to Chanel. However, a cheerful relief
        shortly followed. Fashion critics alike have found that the current state of Chanel was
        missing a certain imagination behind it. Season after season, Viard was falling short in
        creating a fashion line that produced admiration as Karl Lagerfeld, who was the successor
        of Ms. Coco Chanel when the brand was revived in 1983, once did so well at.
      </p>
      <p>
        However, the social buzz &amp; the fiscal growth were not portraying that same deficit.
        Viard, who held the artistic director role for 5 years, contributed to the brand&apos;s
        positive earnings that rose to $19.7 billion in 2023. According to{' '}
        <em>Business of Fashion</em>, &ldquo;The French couture house reported revenues up 16
        percent in 2023 and plans to increase capital expenditure by as much as 50 percent in
        2024&rdquo; (Williams 2024). Fashion is a business, but to be able to run the House of
        Chanel&apos;s business at the high esteem it is placed at, there are many things one must
        consider maintaining that esteem. That includes clothing that can create a social market
        &amp; desire for people to get behind. Even if they are never able to own anything Chanel
        in their lives; the idea of luxury is sold as well. Unfortunately, Viard was simply not
        producing that idea or reality the way many would have liked to see from someone who was
        Lagerfeld&apos;s deputy for decades. With one of the most important roles in fashion
        hiring in the last 40 years, one question is left… Who is next?
      </p>
      <p>
        Many took to social media to share ideas &amp; create threads as to why their favorite
        designer would fit the ethos of the Chanel brand well. A few suggestions seemed ideal,
        while some felt like a fever dream if ever true. Many believe John Galliano, current
        creative director of Maison Margiela, was mentioned quite often. I see how Galliano is a
        first thought; however, it would be a pity to see him leave now while he&apos;s starting to
        create his own code at Margiela. Other suggestions were the minds of Jeremy Scott, who
        animated Moschino for years, Sandy Liang, who embodies the sweet gentle side of Chanel that
        she displays in her namesake brand, Marc Jacobs, whose impact at Louis Vuitton is still
        eminent today, or Sarah Burton, who just finished her tremendous run at Alexander
        McQueen following Mr. Lee himself.
      </p>
      <p>
        Whoever is chosen, I&apos;m sure (or at least praying) Chanel &amp; their higher ups are able
        to make a choice that sustains not only the legacy of the house that Coco, Karl, &amp;
        Virginie have built, but also create a fresh &amp; newly needed push to what Chanel can be
        in this time. Aside from the inevitable monetary growth, creating clothes that fashion
        enthusiasts can aspire to &amp; believe that &lsquo;one day I can be that fabulous
        too&rsquo;. The House of Chanel needs a designer that will take the clothes further than
        the reality to once again create a dream for us to yearn for.
      </p>
    </JournalTextArticlePage>
  )
}
